import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from 'components/Icon';
import { isEpgv2Enabled } from 'helpers/ConfigHelper';
import Style from './MVPDIncomplete.module.scss';

const MVPDIncomplete = ({
  isActive,
  backgroundInline,
  sharedTheme,
  mvpdIncompleteTheme,
  mvpdIncompleteChildren,
  buttonOnClick,
  onClose,
}) => {
  if (!isActive) return null;

  const innerContainerStyle = backgroundInline ? { ...backgroundInline } : {};
  const closeButton = onClose && (
    <div className={mvpdIncompleteTheme.close} onClick={onClose}>
      <Icon color="white" icon="close" size="large" />
    </div>
  );
  const maybeLaterButton = onClose && (
    <span onClick={onClose} className={Style.maybeLaterLink}>
      Maybe Later
    </span>
  );
  return (
    <div
      className={classNames(
        Style.container,
        sharedTheme.container,
        isEpgv2Enabled() ? Style.resizablePlayer : null,
      )}
    >
      <div className={Style.mvpdIncomplete} Style={innerContainerStyle}>
        {closeButton}
        <div className={Style.content}>
          {mvpdIncompleteChildren(buttonOnClick)}
          {maybeLaterButton}
        </div>
      </div>
    </div>
  );
};

export default MVPDIncomplete;

MVPDIncomplete.propTypes = {
  isActive: PropTypes.bool,
  backgroundInline: PropTypes.shape({}),
  sharedTheme: PropTypes.shape({}),
  mvpdIncompleteTheme: PropTypes.shape({}),
  mvpdIncompleteChildren: PropTypes.func,
  buttonOnClick: PropTypes.func,
  onClose: PropTypes.func,
};

MVPDIncomplete.defaultProps = {
  isActive: false,
  backgroundInline: {},
  sharedTheme: {},
  mvpdIncompleteTheme: {},
  mvpdIncompleteChildren: null,
  buttonOnClick: null,
  onClose: null,
};
